import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { lang: "en" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("head", null, [
  /*#__PURE__*/_createElementVNode("meta", { charset: "UTF-8" }),
  /*#__PURE__*/_createElementVNode("meta", {
    "http-equiv": "X-UA-Compatible",
    content: "IE=edge"
  }),
  /*#__PURE__*/_createElementVNode("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0"
  }),
  /*#__PURE__*/_createElementVNode("title", null, "Todos"),
  /*#__PURE__*/_createElementVNode("link", {
    rel: "stylesheet",
    href: "./style.css"
  })
], -1)
const _hoisted_3 = { id: "app" }
const _hoisted_4 = { class: "app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppFilters = _resolveComponent("AppFilters")!
  const _component_AppTodoList = _resolveComponent("AppTodoList")!
  const _component_AppAddTodo = _resolveComponent("AppAddTodo")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("html", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("body", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AppHeader),
        _createVNode(_component_AppFilters, {
          "active-filter": _ctx.activeFilter,
          onSetFilter: _ctx.setFilter
        }, null, 8, ["active-filter", "onSetFilter"]),
        _createElementVNode("main", _hoisted_4, [
          _createVNode(_component_AppTodoList, {
            items: _ctx.filteredItems,
            onToggleItem: _ctx.toggleItem,
            onRemoveItem: _ctx.removeItem
          }, null, 8, ["items", "onToggleItem", "onRemoveItem"]),
          _createVNode(_component_AppAddTodo, { onAddItem: _ctx.addItem }, null, 8, ["onAddItem"])
        ]),
        _createVNode(_component_AppFooter, { stats: _ctx.stats }, null, 8, ["stats"])
      ])
    ])
  ]))
}